import { Component, Input, Output, EventEmitter, ViewChild } from '@angular/core';
import { MatTable } from '@angular/material/table';
import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';
import { MatSort } from '@angular/material/sort';
import { DataBagService } from 'src/app/common/data-bag.service';

export interface PeriodicElement {
	name: string;
	weight: number;
	symbol: string;
}

@Component({
	selector: 'app-optional-trip-multimedias',
	templateUrl: './optional-trip-multimedias.component.html',
	styleUrls: ['./optional-trip-multimedias.component.css'],
})
export class OptionalTripMultimediasComponent {
	@Input() data: any;
	@Input() editable = true;
	@Output() dataChanged = new EventEmitter();

	@ViewChild('dataTable') table: MatTable<PeriodicElement>;
	@ViewChild(MatSort) sort: MatSort;

	constructor(private readonly bag: DataBagService) {}

	displayedColumns: string[] = [`url`, 'name', `order`, 'link', `edit`];

	dropTable(event: CdkDragDrop<PeriodicElement[]>): void {
		moveItemInArray(this.data.optionalTripMultimedia, event.previousIndex, event.currentIndex);
		this.table.renderRows();
	}

	uploadFile(event) {
		this.bag.upload('/multimedia/file/', event.target.files[0], (result, error) => {
			this.data.optionalTripMultimedia.push({
				id: null,
				multimedia: result,
				order: this.data.optionalTripMultimedia.length + 1,
			});

			this.table.renderRows();
		});
	}

	deleteImage(index) {
		this.data.optionalTripMultimedia.splice(index, 1);
		this.table.renderRows();
	}
}
